<script>
import Drawer from "@/components/drawer.vue";
// Custom Components
import PageHeader from "@/components/page-header";
import HotelDetails from "@/components/superAdmin/hotel/hotelDetails.vue";
import PbxConnform from "@/components/superAdmin/pbxForm.vue";
import PmsConnform from "@/components/superAdmin/pmsForm.vue";
import pbxService from "@/helpers/APIService/pbx.service";
import superService from "@/helpers/APIService/super.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import appConfig from "@/app.config";
import { authComputed } from "@/state/helpers";
import handleLogic from "@/helpers/handleLogic";

export default {
  page: {
    title: "Hotel list",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    HotelDetails,
    PageHeader,
    PmsConnform,
    PbxConnform,
  },
  data() {
    return {
      title: "Hotel list",
      hotelData: [],
      isShowHotelForm: false,
      isShowPMSForm: false,
      isShowPBXForm: false,
      selectedHotel: null,
      selectedHotelId: null,
      selectedPBX: null,
      selectedPMS: null,
      isStillLoading: false,
      isEdit: false,
      wifiServiceSelectedHotel: "",
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getHotels();
  },
  methods: {
    // Method is used to get hotel list
    async getHotels() {
      this.isStillLoading = true;
      try {
        const response = await superService.getHotelsList();
        if (response) {
          this.hotelData = response;
          this.isStillLoading = false;
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to handle hotel form
    hotelForm() {
      this.isEdit = false;
      this.selectedHotel = null;
      this.isShowHotelForm = !this.isShowHotelForm;
    },

    // Method is used to handle hotel submission
    handleHotelSubmit(data) {
      if (this.isEdit) {
        this.hotelData = this.hotelData.map((hotel) => {
          if (hotel.id == data.id) {
            hotel = data;
          }
          return hotel;
        });
      } else {
        this.hotelData.push(data);
      }
      this.hotelForm();
    },

    // Method is used to update hotel details
    updateHotelDetail(hotel) {
      this.selectedHotel = hotel;
      this.isEdit = true;
      this.isShowHotelForm = !this.isShowHotelForm;
    },
    // Method is used to handle PBX form
    PBXForm() {
      this.isPBXEdit = false;
      this.selectedPBX = null;
      this.selectedHotelId = null;
      this.isShowPBXForm = !this.isShowPBXForm;
    },
    // Method is used to handle hotel submission
    handlePBXSubmit() {
      this.PBXForm();
      this.getHotels();
    },
    // Method is used to PBX connection
    async getPBXConnList(hotel) {
      try {
        if (hotel.pbx_domain_uuid) {
          const response = await pbxService.getDomainDetailList(
            hotel.pbx_domain_uuid
          );
          this.selectedPBX = response;
        }
        this.selectedHotelId = hotel.id;
        this.isPBXEdit = hotel.pbx_domain_uuid !== null ? true : false;
        this.isShowPBXForm = !this.isShowPBXForm;
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to PBX URl
    goPBXurl(hotel) {
      console.log(hotel);
      window.open(window.location.origin + "/kiosk-status", "_blank");
    },
    // Method is used to handle PMS form
    PMSForm() {
      this.isPMSEdit = false;
      this.selectedPMS = null;
      this.isShowPMSForm = !this.isShowPMSForm;
    },
    // Method is used to PMS connection
    async getPMSConnList(hotel) {
      try {
        const response = await superService.gePMSConnList(`?hotel=${hotel.id}`);
        this.selectedPMS = response[0];
        this.isPMSEdit = hotel.is_pms_connection ? true : false;
        this.isShowPMSForm = !this.isShowPMSForm;
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is use for maintained guest avatar
    avatarGenerator(name) {
      return Middleware.avatarGenerator(name);
    },
    // Method is used to copy code
    copyCode(data, copy_for) {
      if (copy_for == "wifi") {
        this.wifiServiceSelectedHotel = data;
        if (data.is_wifi_service) {
          Middleware.copyCode(data.id, "Location id is copied.");
        }
        this.$bvModal.show("wifi-service-enable-modal");
      } else {
        Middleware.copyCode(data);
      }
    },
    // Method is used to open domain
    openDomain(hotel) {
      if (hotel.pbx_domain_uuid !== null) {
        handleLogic.openPbxDomain({
          domain_uuid: hotel.pbx_domain_uuid,
          hotel_id: hotel.id,
        });
      }
    },
    // Method is used to open guest portal
    openGuestPortal(property_code) {
      window.open(
        `${process.env.VUE_APP_GUEST_PORTAL_BASE_URL}?app_type=hd&hc=${property_code}&utm_source=link`,
        "_blank"
      );
    },
    // Method is used to handle change of wifi service
    handleWifiServiceChange(id, data) {
      superService
        .updateHotel(id, data)
        .then((response) => {
          if (response) {
            Middleware.notification(
              "Wifi servic change successfully !!",
              "success"
            );
            if (response.is_wifi_service == true) {
              this.copyCode(response);
            }
            this.$bvModal.hide("wifi-service-enable-modal");
            this.hotelData.map((item) => {
              if (item.id == response.id) {
                item.is_wifi_service = response.is_wifi_service;
              }
              return item;
            });
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
  },
};
</script>
<template>
  <div>
    <PageHeader
      :title="title"
      :action="hotelForm"
      text="Add New Hotel"
      :isButton="true"
    />
    <b-card>
      <div class="mb-3 d-none">
        <div class="row align-items-center">
          <div class="col-md-2">
            <input
              type="text"
              class="form-control mb-0"
              placeholder="search phone number"
            />
          </div>
          <div class="col-md-2">
            <input
              type="text"
              class="form-control mb-0"
              placeholder="search domain name"
            />
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-2">
            <input
              type="text"
              class="form-control mb-0"
              placeholder="search trunk group"
            />
          </div>
          <div class="col-md-2">
            <b-form-select class="form-select" id="company-type-input">
            </b-form-select>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-1">
            <button class="btn btn-sm btn-primary d-block ms-auto">
              Clear Filter
            </button>
          </div>
        </div>
      </div>
      <div class="table-responsive" v-dragscroll="true">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th>Name</th>
              <th>Domain</th>
              <th>Address</th>
              <th>City</th>
              <th>State</th>
              <th>Country</th>
              <th>E-mail</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody v-if="isStillLoading">
            <tr v-for="item in 20" :key="item">
              <td class="placeholder-glow" v-for="no in 8" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="hotel in hotelData" :key="hotel.id">
              <td>
                <img
                  v-if="hotel.logo != null"
                  class="rounded-circle picture-img"
                  :src="hotel.logo"
                  alt="Avatar"
                />
                <span v-if="hotel.logo != null" class="ms-1">
                  {{ hotel.name }}
                  (<span
                    class="text-primary text-uppercase"
                    v-b-popover.hover.top="'click to open guestxp'"
                    @click="openGuestPortal(hotel.property_code)"
                  >
                    {{ hotel.property_code }}
                  </span>
                  <i
                    class="far fa-copy text-primary ms-1"
                    @click="copyCode(hotel.property_code)"
                  >
                  </i
                  >)
                </span>
                <div
                  v-if="hotel.logo == null"
                  class="d-flex align-items-center"
                >
                  <span
                    class="d-flex align-items-center justify-content-center avatar-md-title bg-soft bg-primary text-secondary font-20 rounded-circle picture-img"
                  >
                    {{ avatarGenerator(hotel.name) }}
                  </span>
                  <span class="ms-2">
                    {{ hotel.name }}
                    (<span
                      class="text-primary text-uppercase"
                      v-b-popover.hover.top="'click to open guestxp'"
                      @click="openGuestPortal(hotel.property_code)"
                    >
                      {{ hotel.property_code }}
                      <i
                        class="far fa-copy text-primary ms-1"
                        @click="copyCode(hotel.property_code)"
                      ></i> </span
                    >)</span
                  >
                </div>
              </td>
              <td>
                <span @click="openDomain(hotel)" class="text-primary cursor">
                  {{
                    hotel.pbx_domain_name !== null ? hotel.pbx_domain_name : "-"
                  }}
                </span>
                <i
                  v-if="hotel.pbx_domain_name !== null"
                  class="far fa-copy text-primary ms-1"
                  @click="copyCode(hotel.pbx_domain_name)"
                ></i>
              </td>
              <td @click="updateHotelDetail(hotel)">
                <div class="overflow-tip w-250">
                  <span>{{ hotel.address ? hotel.address : "-" }}</span>
                </div>
              </td>
              <td
                class="text-left text-capitalize"
                @click="updateHotelDetail(hotel)"
              >
                {{ hotel.city ? hotel.city : "Not Specified" }}
              </td>
              <td @click="updateHotelDetail(hotel)">
                {{ hotel.state ? hotel.state : "-" }}
              </td>
              <td
                class="text-left text-capitalize"
                @click="updateHotelDetail(hotel)"
              >
                {{ hotel.country ? hotel.country : "-" }}
              </td>
              <td @click="updateHotelDetail(hotel)">
                {{ hotel.email ? hotel.email : "-" }}
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <i
                    class="fas fa-pencil-alt text-success me-2"
                    @click="updateHotelDetail(hotel)"
                  ></i>
                  <i
                    @click="getPBXConnList(hotel)"
                    class="mdi mdi-phone-dial-outline fs-5 me-2"
                    v-b-popover.hover="'pbx conn'"
                    :class="
                      hotel.pbx_domain_uuid !== null
                        ? 'text-success'
                        : 'text-secondary'
                    "
                  ></i>
                  <i
                    @click="getPMSConnList(hotel)"
                    v-b-popover.hover="'pms conn'"
                    class="mdi mdi-card-bulleted-settings-outline fs-5 me-2"
                    :class="
                      hotel.is_pms_connection == true
                        ? 'text-success'
                        : 'text-secondary'
                    "
                  ></i>
                  <i
                    @click="copyCode(hotel, 'wifi')"
                    class="mdi mdi-wifi fs-5"
                    :class="
                      hotel.is_wifi_service ? 'text-success' : 'text-secondary'
                    "
                    v-b-popover.hover="
                      hotel.is_wifi_service ? 'Copy Wifi portal code.' : ''
                    "
                  ></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>

    <!-- HOTEL FORM -->
    <Drawer
      @close="hotelForm"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1100"
    >
      <div v-if="isShowHotelForm">
        <HotelDetails
          :hotelDetails="this.selectedHotel"
          :isEdit="this.isEdit"
          @cancelSubmit="hotelForm"
          @submitted="handleHotelSubmit"
        />
      </div>
    </Drawer>

    <!-- PBX FORM -->
    <Drawer
      @close="PBXForm"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1004"
      :maxWidth="1000"
    >
      <div v-if="isShowPBXForm">
        <PbxConnform
          :pbx-form="this.selectedPBX"
          :hotelId="this.selectedHotelId"
          :isEdit="this.isPBXEdit"
          @cancelSubmit="PBXForm"
          @submitted="handlePBXSubmit"
        />
      </div>
    </Drawer>

    <!-- PMS Form -->
    <Drawer
      @close="PMSForm"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1004"
      :maxWidth="1000"
    >
      <div v-if="isShowPMSForm">
        <PmsConnform
          :pmsForm="this.selectedPMS"
          :isEdit="this.isPMSEdit"
          @cancelSubmit="PMSForm"
          @submitted="PMSForm"
        />
      </div>
    </Drawer>

    <!-- Modal is used to change wifi service -->
    <b-modal
      id="wifi-service-enable-modal"
      centered
      title="Update Wifi service"
      hide-footer
      size="sm"
      title-class="font-18"
    >
      <div v-if="wifiServiceSelectedHotel" class="text-center">
        <label for="wifi_service">Wifi Service</label>
        <div
          class="form-check form-switch my-1 d-flex alig-items-center justify-content-center"
          slot="wifi_service"
        >
          <input
            class="form-check-input"
            id="wifi_service"
            type="checkbox"
            v-b-popover.hover="'Click to change wifi service.'"
            v-model="wifiServiceSelectedHotel.is_wifi_service"
            @change="
              handleWifiServiceChange(wifiServiceSelectedHotel.id, {
                is_wifi_service: wifiServiceSelectedHotel.is_wifi_service,
              })
            "
          />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.w-250 {
  width: 250px;
}
</style>

<!-- <i
@click="
  hotel.pbx_domain_uuid !== null ? goPBXurl(hotel) : ''
"
v-b-popover.hover="'view'"
class="mdi mdi-eye fs-5 me-2"
:class="
  hotel.pbx_domain_uuid !== null
    ? 'text-success'
    : 'text-secondary'
"
></i> -->
